export const INSIDE_ORBIT_MENU_CONTAINER = 'inside-orbit-menu-container';